// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '../config/configuration'
import store from './store/store'
import api from './api/api'
import axios from 'axios'
import moment from 'moment'
/* eslint-disable no-new */

import showLoading from './components/common/dc-loading/dc-loading'

// 国际化
import VueI18n from 'vue-i18n'
import 'vant/lib/index.css'
import {List, PullRefresh, Swipe, SwipeItem, Picker, Toast, Tab, Tabs, RadioGroup, Radio, Popup, Loading} from 'vant'

// import Vconsole from 'vconsole';
// const vConsole =new Vconsole();
// Vue.use(vConsole);

// sentry 前端错误收集
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import common from '../static/js/common'
// moment.lang('zh-cn');

Vue.prototype.$axios = axios
Vue.prototype.$api = api
Vue.prototype.$moment = moment

Vue.config.productionTip = false
Vue.component('dc-loading', showLoading)

Vue.use(VueI18n)

let lang = window.sessionStorage.getItem('lang') || 'zh-CN'
const i18n = new VueI18n({
    locale: lang, // 语言标识
    fallbackLocale: 'zh-CN', // 没有英文的时候默认中文语言
    silentFallbackWarn: true, // 抑制警告
    // this.$i18n.locale // 通过切换locale的值来实现语言切换
    messages: {
        'zh-CN': require('../static/js/lang/zh.js'), // 中文语言包
        'en-US': require('../static/js/lang/en.js') // 英文语言包
    }
})

Vue.use(List).use(PullRefresh).use(Swipe).use(SwipeItem).use(Picker).use(Toast).use(Tab).use(Tabs).use(RadioGroup).use(Radio).use(Popup).use(Loading)

process.env.NODE_ENV === 'production' && Sentry.init({
    dsn: 'https://43c03e0fef6a46c699e6463505839f13@js-track.datacastle.cn/4',
    integrations: [new Integrations.Vue({Vue, attachProps: true, logErrors: true, tracing: true})],
    release: process.env.VUE_APP_Version,
    tracesSampleRate: 1.0
})

// 全局注册一个时间格式过滤器
Vue.filter('formatCommon', function (time, format, type) {
    if (time !== '' && time !== null) {
        time = Number(time) ? Number(time) : time
        let t = new Date(time)
        let tf = function (i) {
            return (i < 10 ? '0' : '') + i
        }
        return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
            switch (a) {
                case 'yyyy':
                    return tf(t.getFullYear())
                case 'MM':
                    return tf(t.getMonth() + 1)
                case 'mm':
                    return tf(t.getMinutes())
                case 'dd':
                    return tf(t.getDate())
                case 'HH':
                    return tf(t.getHours())
                case 'ss':
                    return tf(t.getSeconds())
            }
        })
    } else {
        var emptys = '--'
        if (type === 'empty') {
            return ''
        } else {
            return emptys
        }
    }
})

api.getToken({
    fail: false
}).then(res => {
    // res.data.id = res.data.userId;
    // res.data.data.token = common.getCookie('sso_global_session')
    if (res.data.loginFlag) {
        localStorage.setItem('loginUser', JSON.stringify(res.data.data))
    } else {

    }
})

window.vm = new Vue({
    el: '#app',
    router,
    i18n,
    store,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js